module.exports = {
          srcSet: __webpack_public_path__ + "586706fc814c59af9af10f7f51a9efba-360.png"+" 360w",
          images:[ {path: __webpack_public_path__ + "586706fc814c59af9af10f7f51a9efba-360.png",width: 360,height: 656}],
          src: __webpack_public_path__ + "586706fc814c59af9af10f7f51a9efba-360.png",
          toString:function(){return __webpack_public_path__ + "586706fc814c59af9af10f7f51a9efba-360.png"},
          
          width: 360,
          height: 656
        }